import '@/js/dist/www.iichi.com/common';

document.addEventListener('DOMContentLoaded', () => {
  const stateEl = document.querySelector('#state') as HTMLSelectElement;
  stateEl.addEventListener('change', () => {
    const formEl = document.querySelector('.filter-area form') as HTMLFormElement;
    formEl.submit();
  });
});
